import { Address, ShopProductConfiguration } from '@cobra/interfaces-enums-mocks/interfaces';
import { OrderProcessStepId } from '../constants/process-settings';
import { StorageKey } from '../constants';
import { get, remove, set } from './session-storage.service';
import { CheckoutType } from '@cobra/interfaces-enums-mocks/enums';

export const getStoredAvailableProducts = () => get<number[]>(StorageKey.AVAILABLE_PRODUCTS);
export const storeAvailableProducts = (value: number[]) => set<number[]>(StorageKey.AVAILABLE_PRODUCTS, value);
export const removeStoredAvailableProducts = () => remove(StorageKey.AVAILABLE_PRODUCTS);

export const getStoredVerifiedAddress = () => get<Address>(StorageKey.VERIFIED_ADDRESS);
export const storeVerifiedAddress = <T = Address>(value: T) => set<T>(StorageKey.VERIFIED_ADDRESS, value);
export const removeStoredVerifiedAddress = () => remove(StorageKey.VERIFIED_ADDRESS);

export const getStoredProductConfig = () => get<ShopProductConfiguration>(StorageKey.PRODUCT_CONFIG);
export const storeProductConfig = (value: ShopProductConfiguration) =>
    set<ShopProductConfiguration>(StorageKey.PRODUCT_CONFIG, value);
export const removeStoredProductConfig = () => remove(StorageKey.PRODUCT_CONFIG);

export const getStoredProductConfigSteps = () => get<OrderProcessStepId[]>(StorageKey.PRODUCT_CONFIG_STEPS);
export const storeProductConfigSteps = (value: OrderProcessStepId[]) =>
    set<OrderProcessStepId[]>(StorageKey.PRODUCT_CONFIG_STEPS, value);
export const removeStoredProductConfigSteps = () => remove(StorageKey.PRODUCT_CONFIG_STEPS);

export const getStoredSearchUuid = () => get<string>(StorageKey.SEARCH_UUID);
export const storeSearchUuid = (value: string) => set<string>(StorageKey.SEARCH_UUID, value);
export const removeStoredSearchUuid = () => remove(StorageKey.SEARCH_UUID);

export const getStoredCheckoutType = () => get<CheckoutType>(StorageKey.CHECKOUT_TYPE);
export const storeCheckoutType = <T = CheckoutType>(value: T) => set<T>(StorageKey.CHECKOUT_TYPE, value);
export const removeStoredCheckoutType = () => remove(StorageKey.CHECKOUT_TYPE);

export const removeAll = () => {
    removeStoredAvailableProducts();
    removeStoredVerifiedAddress();
    removeStoredProductConfig();
    removeStoredProductConfigSteps();
    removeStoredSearchUuid();
    removeStoredCheckoutType();
};
